import React from "react";
import { BidderGroupList } from "./BidderGroupList";
import { useRouter } from "next/router";
import { EmptyListFallback } from "./EmptyListFallback";

interface BidderGroupsProps {
  biddersData: {
    listing_id: string;
    bidders: any[];
  }[];
  refreshPage: () => void;
}

export const BidderGroups: React.FC<BidderGroupsProps> = ({
  biddersData,
  refreshPage,
}) => {
  const router = useRouter();
  return biddersData?.length > 0 ? (
    <ul role="list" className="space-y-5  overflow-hidden bg-white  ">
      {biddersData?.map((group, index) => (
        <li key={`${group?.listing_id}-${index}`} className="border rounded-xl">
          <div className="bg-brand-lightBlue  px-4 py-2  rounded-t-xl">
            <p
              onClick={() => {
                if (group?.listing_id)
                  router.push(`/dashboard/events/${group?.listing_id}`);
              }}
              className="text-sm font-semibold text-gray-700 hover:cursor-pointer hover:underline w-fit"
            >
              Event: {group.listing_id}
            </p>
          </div>
          <BidderGroupList refreshPage={refreshPage} bidders={group.bidders} />
        </li>
      ))}
    </ul>
  ) : (
    <EmptyListFallback
      title="No KYC Request"
      message="There are no pending KYC Requests"
    />
  );
};
